import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
} from '@infotech/lib-api-middleware'
import { TOIR_CORE_URL } from './constants'

export const TOIR_STATUSES_SCHEMA_NAME = `toirStatuses`
export const URL = `${TOIR_CORE_URL}/core/issues/statuses`

const toirStatusesSchema = new schema.Entity(TOIR_STATUSES_SCHEMA_NAME)
export const toirStatusesSelector = createSelectorForEntityKey(TOIR_STATUSES_SCHEMA_NAME)
export const toirStatusesEntitiesSelector = createEntitiesSelector(TOIR_STATUSES_SCHEMA_NAME)
export const toirStatusesApiActions = actionCrudCreatorsFor(TOIR_STATUSES_SCHEMA_NAME, URL, toirStatusesSchema)
